import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohyderabadcabs() {



const cardData = {
  keyword: "Pune to Hyderabad Cabs",
  heading: "Lotus Cab: Pune to Hyderabad Cabs",

  headingDescription:
    "Lotus Cab offers reliable Pune to Hyderabad cab services designed for safe, comfortable, and long-distance interstate travel. Covering approximately 560–600 km, this route connects Maharashtra to Telangana via well-maintained national highways. Whether you require a one-way drop, round-trip taxi, corporate travel solution, or family vacation cab, we provide flexible booking options with transparent per kilometer pricing. Our fleet includes AC sedans, spacious SUVs, and luxury vehicles driven by experienced highway chauffeurs. Ideal for business trips, IT sector travel, relocation journeys, and weekend family plans, we ensure punctual pickup and smooth travel. With easy online booking and 24/7 support, Lotus Cab makes your Pune to Hyderabad journey stress-free and dependable.",

  top: "Top Places to Visit in Hyderabad with Lotus Cab",

  topPlaces: [
    {
      title: "Charminar",
      description:
        "Charminar is Hyderabad’s most iconic landmark and a symbol of the city’s rich heritage. Located in the heart of Old City, it attracts tourists from across India. Families and groups traveling from Pune often include Charminar in their sightseeing itinerary. Comfortable AC cab service ensures relaxed arrival after long-distance travel. Lotus Cab provides flexible local travel options within Hyderabad."
    },
    {
      title: "Golconda Fort",
      description:
        "Golconda Fort is a historic architectural marvel known for its acoustic system and panoramic city views. Corporate and family travelers frequently visit this attraction. SUV taxis are ideal for comfortable group sightseeing."
    },
    {
      title: "Ramoji Film City",
      description:
        "Ramoji Film City is one of the largest film studio complexes in the world. Many tourists book round-trip Pune to Hyderabad cabs specifically to visit this entertainment destination. Spacious vehicles ensure luggage comfort for extended stays."
    },
    {
      title: "Hussain Sagar Lake",
      description:
        "Hussain Sagar Lake offers scenic views and boating experiences. Evening visits are popular among families and couples. AC sedans ensure comfortable city travel."
    },
    {
      title: "Birla Mandir",
      description:
        "Birla Mandir is a peaceful white marble temple offering panoramic city views. Devotees traveling from Pune prefer chauffeur-driven cab services for smooth temple visits."
    },
    {
      title: "Salar Jung Museum",
      description:
        "Salar Jung Museum houses rare art collections from around the world. Corporate visitors and families often add this destination to their Hyderabad tour plan."
    },
    {
      title: "Mecca Masjid",
      description:
        "One of India’s oldest and largest mosques, Mecca Masjid reflects Hyderabad’s cultural heritage. Comfortable outstation taxi service ensures stress-free sightseeing."
    },
    {
      title: "HiTech City",
      description:
        "HiTech City is Hyderabad’s IT and business hub. Corporate travelers frequently book Pune to Hyderabad cabs for business meetings and professional visits."
    }
  ],

  services: [
    {
      name: "Pune to Hyderabad Cabs",
      description:
        "Lotus Cab provides dependable Pune to Hyderabad cab service for long-distance travel with transparent per km pricing. Ideal for business trips, family vacations, relocation travel, and corporate meetings. Our fleet includes AC sedans and spacious SUVs. Professional highway-experienced drivers ensure safe interstate travel. Flexible one-way and round-trip booking options available."
    },
    {
      name: "Pune to Hyderabad One Way Cab",
      description:
        "Affordable one-way cab service from Pune to Hyderabad where customers pay only for single-side travel distance. Perfect for airport transfers, shifting, and corporate travel needs."
    },
    {
      name: "Pune to Hyderabad Round Trip Taxi",
      description:
        "Convenient round-trip taxi packages with flexible return schedules suitable for business visits, family vacations, and extended stays."
    },
    {
      name: "SUV Cab Pune to Hyderabad",
      description:
        "Spacious SUV taxis ideal for group tours, family travel, and corporate teams with ample luggage space and comfortable seating."
    },
    {
      name: "Luxury Cab Pune to Hyderabad",
      description:
        "Premium luxury cab service offering enhanced comfort and executive travel experience for long-distance interstate journeys."
    },
    {
      name: "Corporate Cab Pune to Hyderabad",
      description:
        "Professional cab solutions tailored for corporate meetings, IT travel, employee transport, and business delegations."
    },
    {
      name: "Online Booking Pune to Hyderabad",
      description:
        "Instant online cab booking with secure payment options, transparent fare details, and 24/7 customer support assistance."
    },
    {
      name: "Outstation Taxi Service Pune to Hyderabad",
      description:
        "Reliable outstation taxi service with experienced chauffeurs, AC vehicles, and transparent billing for comfortable interstate travel."
    }
  ],

  tableData: [
    ["Pune to Hyderabad Cabs", "Pune to Hyderabad One Way Cab"],
    ["Pune to Hyderabad Round Trip Taxi", "Affordable Cab Pune to Hyderabad"],
    ["Luxury Cab Pune to Hyderabad", "SUV Cab Pune to Hyderabad"],
    ["Sedan Taxi Pune to Hyderabad", "Family Trip Cab Pune to Hyderabad"],
    ["Corporate Cab Pune to Hyderabad", "Weekend Trip Taxi Pune to Hyderabad"],
    ["AC Cab Pune to Hyderabad", "Online Booking Pune to Hyderabad"],
    ["Best Outstation Cab Pune to Hyderabad", "Per Km Rate Pune to Hyderabad"],
    ["Same Day Return Cab Pune to Hyderabad", "Group Tour Cab Pune to Hyderabad"],
    ["Picnic Cab Pune to Hyderabad", "Outstation Taxi Service Pune to Hyderabad"],
    ["Chauffeur Driven Cab Pune to Hyderabad", "Budget Luxury Cab Pune to Hyderabad"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Safe Interstate Travel",
      WhyChoosedescription:
        "Experienced drivers with long-distance highway expertise ensure safe and smooth interstate travel from Pune to Hyderabad."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and competitive per kilometer pricing model with no hidden charges."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Well-maintained air-conditioned sedans and SUVs for extended road journeys."
    },
    {
      WhyChooseheading: "Flexible Travel Options",
      WhyChoosedescription:
        "One-way, round-trip, and customized packages based on your schedule."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Professional transport solutions tailored for IT companies and business travelers."
    },
    {
      WhyChooseheading: "Family-Friendly Travel",
      WhyChoosedescription:
        "Spacious and comfortable vehicles suitable for long-distance family vacations."
    },
    {
      WhyChooseheading: "Doorstep Pickup in Pune",
      WhyChoosedescription:
        "Convenient pickup from homes, offices, railway stations, and airport."
    },
    {
      WhyChooseheading: "24/7 Customer Assistance",
      WhyChoosedescription:
        "Round-the-clock booking support and travel coordination assistance."
    }
  ]
};

const faqData = [
  { question: "What is the distance from Pune to Hyderabad?", answer: "The distance is approximately 560–600 km and takes around 10–12 hours by road." },
  { question: "Is one-way taxi available?", answer: "Yes, affordable one-way cab service is available." },
  { question: "Are SUV options available?", answer: "Yes, SUV taxis are available for family and group travel." },
  { question: "Is fare calculated per km?", answer: "Yes, transparent per kilometer billing is followed." },
  { question: "Is round-trip booking available?", answer: "Yes, flexible round-trip taxi packages are offered." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with confirmation is available." },
  { question: "Is corporate travel supported?", answer: "Yes, corporate cab packages are available for business travel." },
  { question: "Are drivers experienced?", answer: "Yes, professional and highway-trained chauffeurs ensure safe travel." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback:
      "Booked Pune to Hyderabad cab for corporate travel. Smooth ride, professional driver, and transparent pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Deshmukh",
    feedback:
      "Family trip to Hyderabad was comfortable and safe. AC SUV was spacious and well-maintained.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable long-distance cab service for business travel between Pune and Hyderabad. Highly recommended.",
    rating: 5
  }
];




















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hyderabad Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-hyderabad-cabs.jpg", 
  "description": "Lotus Cab offers reliable taxi services from Pune to Hyderabad for one-way trips, round trips, family travel, corporate trips, weekend getaways, and group tours. Options include luxury, SUV, AC, and sedan cabs with chauffeur service, affordable per km rates, same-day return, and seamless online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-hyderabad-cabs"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Hyderabad Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to Hyderabad with Lotus Cab. One-way, round-trip, weekend, family & corporate trips. Luxury, SUV & AC cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Hyderabad Cabs, Pune to Hyderabad One Way Cab, Pune to Hyderabad Round Trip Taxi, Affordable Cab Pune to Hyderabad, Luxury Cab Pune to Hyderabad, SUV Cab Pune to Hyderabad, Sedan Taxi Pune to Hyderabad, Family Trip Cab Pune to Hyderabad, Corporate Cab Pune to Hyderabad, Weekend Trip Taxi Pune to Hyderabad, AC Cab Pune to Hyderabad, Online Booking Pune to Hyderabad, Best Outstation Cab Pune to Hyderabad, Per Km Rate Pune to Hyderabad, Same Day Return Cab Pune to Hyderabad, Group Tour Cab Pune to Hyderabad, Picnic Cab Pune to Hyderabad, Outstation Taxi Service Pune to Hyderabad, Chauffeur Driven Cab Pune to Hyderabad, Budget Luxury Cab Pune to Hyderabad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetohyderabadcabs;